import { OwaDate, addWeeks, endOfWeek, now, isAfter } from 'owa-datetime';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export function isDateAfterNextWeek(owaStartDate: OwaDate): boolean {
    const userWeekStartDay = getUserConfiguration()?.UserOptions?.WeekStartDay || 0;
    const nextWeek = addWeeks(now(), 1);
    const endOfNextWeek = endOfWeek(nextWeek, userWeekStartDay);
    return isAfter(owaStartDate, endOfNextWeek);
}
